const defaultOptions: RequestInit = {
  credentials: 'include',
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
};
const isObject = (value: unknown): value is Record<string, any> => {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
};
const deepMerge = <T extends Record<string, any>,>(target: T, source: T): T => {
  const result = {
    ...target
  };
  for (const key in source) {
    if (isObject(source[key]) && key in target && isObject(target[key])) {
      result[key] = deepMerge(target[key], source[key]);
    } else {
      result[key] = source[key];
    }
  }
  return result;
};
const customFetch = async (url: string, options: RequestInit) => {
  const mergedOptions = deepMerge(defaultOptions, options);
  const response = await fetch(url, mergedOptions);
  return response;
};
export default customFetch;